import { Box } from "@mui/material"
import type { FC } from "react"

import { buildDuplicateWarningDialogMessage } from "../../utils"

import { DuplicateRow } from "./DuplicateRow"

import { ConfirmationDialog } from "@/components/common/Modals"
import type { Invoice } from "@/graphql/codegen/graphql"

interface DuplicateWarningDialogProps {
  duplicates: Invoice[]
  onCancel: () => void
  onBypass: () => void
  onReview: (invoiceId: string) => void
}

export const DuplicateWarningDialog: FC<DuplicateWarningDialogProps> = ({
  duplicates,
  onCancel,
  onBypass,
  onReview,
}) => {
  const content = (
    <Box className='flex flex-col items-center gap-4'>
      <span>{buildDuplicateWarningDialogMessage(duplicates.length)}</span>
      <Box className='flex flex-col items-center gap-4 pt-2'>
        {duplicates.map((duplicate, index) => (
          <DuplicateRow key={duplicate.invoiceId} invoice={duplicate} index={index} onReview={onReview} />
        ))}
      </Box>
    </Box>
  )

  return (
    <ConfirmationDialog
      title='Possible duplicate invoice(s) detected.'
      content={content}
      closeLabel='Go Back'
      confirmLabel='Add Invoice Anyway'
      onClose={onCancel}
      onConfirm={onBypass}
    />
  )
}
